import {
  DataTableColumnBadgeProps,
  DataTableColumnDateProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '../../../../components/data-table-builder/data-table.types';
import { PpmRepository } from '@/store/ppm-state/ppm-state.repository';

interface getPpmHistoryDataTableStructureProps {
  store: PpmRepository;
  rowActions?: DataTableRowActions;
}

export const getPpmHistoryDataTableStructure = ({ store, rowActions }: getPpmHistoryDataTableStructureProps): DynamicDataTable => {
  const refColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'ppm.table.name',
    accessorKey: 'ref',
    variant: DataTableColumnVariant.TEXT,
  };

  const processStepColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'ppm.table.processStep',
    accessorKey: 'etapeProcess',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string) => {
      if (!value) return { value: 'Non défini', class: 'opacity-70' };
      return { value };
    },
  };

  const anneeColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'ppm.table.year',
    accessorKey: 'annee',
    variant: DataTableColumnVariant.TEXT,
  };

  const statusColumn: DynamicDataTableColumn<DataTableColumnBadgeProps> = {
    label: 'ppm.table.status',
    accessorKey: 'status',
    variant: DataTableColumnVariant.BADGE,
    renderAs: (value: string) => {
      return {
        value: `paa.status.${value}`,
      };
    },
    props: {
      getSeverity: (value: string) => {
        if (value === 'BROUILLON') return 'primary';
        if (value === 'EN_TRAITEMENT') return 'contrast';
        if (value === 'VALIDE') return 'success';
        if (value === 'PUBLIE') return 'info';
        return 'danger';
      },
    },
  };

  const budgetColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'ppm.table.budget',
    accessorKey: 'budgetEstime',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: number) => {
      if (value) {
        return { value: value };
      }
      return { value: 'Non défini', class: 'opacity-70' };
    },
  };

  const createdAtColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'ppm.table.created_at',
    accessorKey: 'metadata.createdAt',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  const updatedAtColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'ppm.table.updated_at',
    accessorKey: 'metadata.updatedAt',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  // const createdByColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
  //   label: 'ppm.table.created_by',
  //   accessorKey: 'metadata.createdBy',
  //   variant: DataTableColumnVariant.TEXT,
  // };
  //
  // const updatedByColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
  //   label: 'ppm.table.updated_by',
  //   accessorKey: 'metadata.updatedBy',
  //   variant: DataTableColumnVariant.TEXT,
  // };

  return {
    singular: 'ppm.singular_history',
    plural: 'ppm.plural_history',
    data: [],
    columns: [refColumn, anneeColumn, statusColumn, processStepColumn, budgetColumn, createdAtColumn, updatedAtColumn], //Commented createdByColumn, updatedByColumn, budgetColumn
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    target: row => store.setState(row),
    rowActions,
    searchableFields: ['ref', 'annee', 'status'],
  };
};
